const visibleColumns = [
  {
    title: "General Availability ID",
    field: "GENERAL_AVAILIBILITY_ID",
    locked: false,
    filter: "text",
    width: "200",
    show: true,
  },
  {
    title: "Announcement ID",
    field: "ANNOUNCEMENT_ID",
    locked: false,
    filter: "text",
    width: "200",
    show: true,
  },
  {
    title: "Eligibility ID",
    field: "ELIGIBILITY_ID",
    locked: false,
    filter: "text",
    width: "200",
    show: true,
  },
  {
    title: "Application ID",
    field: "APPLICATION_ID",
    locked: false,
    filter: "text",
    width: "200",
    show: true,
    className: "text-end",
  },
  {
    title: "Applicant SSN",
    field: "APPLICANT_SSN",
    locked: false,
    filter: "text",
    width: "200",
    show: false,
    className: "text-end",
  },
  {
    title: "Evaluation Rating",
    field: "EVALUATION_RATING",
    locked: false,
    filter: "number",
    width: "150",
    show: false,
    className: "text-end",
  },
  {
    title: "Created On",
    field: "CREATED_ON",
    locked: false,
    filter: "date",
    format: "MM/DD/YYYY",
    editor: "date",
    width: "220",
    show: false,
  },
  {
    title: "Updated On",
    field: "UPDATED_ON",
    locked: false,
    filter: "date",
    format: "MM/DD/YYYY",
    editor: "date",
    width: "220",
    show: false,
  },
  {
    title: "Status",
    field: "status",
    locked: false,
    filter: "text",
    width: "150",
    show: true,
  },
  {
    title: "Notified On",
    field: "Notifiedon",
    locked: false,
    filter: "date",
    format: "MM/DD/YYYY",
    editor: "date",
    width: "220",
    show: true,
  },
  {
    title: "Remark",
    field: "Remark",
    locked: false,
    filter: "text",
    width: "200",
    show: false,
  },
  // {
  //   title: "Backup",
  //   field: "Backup",
  //   locked: false,
  //   filter: "boolean",
  //   width: "100",
  //   show: true,
  // },
  // {
  //   title: "Auto Reminder",
  //   field: "AutoReminder",
  //   locked: false,
  //   filter: "boolean",
  //   width: "150",
  //   show: true,
  // },
  {
    title: "Created on Log Date",
    field: "Createdon_logdate",
    locked: false,
    filter: "date",
    format: "MM/DD/YYYY",
    editor: "date",
    width: "220",
    show: false,
  },
  {
    title: "Action",
    field: "Action",
    locked: false,
    filter: "text",
    width: "150",
    show: true,
  },
  {
    title: "Action Type",
    field: "ActionType",
    locked: false,
    filter: "text",
    width: "150",
    show: true,
  },
  {
    title: "Activity",
    field: "Activity",
    locked: false,
    filter: "text",
    width: "200",
    show: false,
  },
  {
    title: "Contacted",
    field: "Contacted",
    locked: false,
    filter: "text",
    width: "200",
    show: false,
  },
  {
    title: "Scheduled",
    field: "Scheduled",
    locked: false,
    filter: "text",
    width: "200",
    show: false,
  },
  {
    title: "Interviewed",
    field: "Interviewed",
    locked: false,
    filter: "text",
    width: "200",
    show: false,
  },
  {
    title: "Selected",
    field: "Selected",
    locked: false,
    filter: "text",
    width: "200",
    show: false,
  },
  {
    title: "Not Selected",
    field: "NotSelected",
    locked: false,
    filter: "text",
    width: "200",
    show: false,
  },
  {
    title: "Not Considered",
    field: "NotConsidered",
    locked: false,
    filter: "text",
    width: "200",
    show: false,
  },
  {
    title: "Scheduled Date",
    field: "ScheduledDate",
    locked: false,
    filter: "date",
    format: "MM/DD/YYYY",
    editor: "date",
    width: "220",
    show: false,
  },
  {
    title: "Certification PID",
    field: "CERTIFICATION_PID",
    locked: false,
    filter: "text",
    width: "200",
    show: false,
  },
  {
    title: "Status Code",
    field: "StatusCode",
    locked: false,
    filter: "text",
    width: "150",
    show: false,
  },
  {
    title: "Reschedule",
    field: "reschedule",
    locked: false,
    filter: "text",
    width: "150",
    show: false,
  },
  {
    title: "Reschedule Date",
    field: "Reschedule_date",
    locked: false,
    filter: "date",
    format: "MM/DD/YYYY",
    editor: "date",
    width: "220",
    show: false,
  },
  {
    title: "Certification List ID",
    field: "CERT_LIST_ID",
    locked: false,
    filter: "text",
    width: "200",
    show: false,
  },
  // {
  //   title: "Total Count",
  //   field: "TotalCount",
  //   locked: false,
  //   filter: "number",
  //   width: "150",
  //   show: true,
  // },
];

export default visibleColumns;
